var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStyleguides(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn_style",
    transform: "translate(-2.72 -0.48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1219",
    "data-name": "Rectangle 1219",
    width: 24,
    height: 24,
    transform: "translate(2.72 0.48)",
    fill: "rgba(255,255,255,0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M.387,14.51A.376.376,0,0,1,0,14.149V1.867a.378.378,0,0,1,.387-.36H1.673v.721H.768V13.789H18.581V2.228h-.905V1.507h1.286a.378.378,0,0,1,.387.36V14.149a.377.377,0,0,1-.387.36Zm9.18-.869a.173.173,0,0,1-.086-.044c-.019-.007-.032-.027-.052-.039-1.837-1.772-2.821-1.344-4.062-.8a4.124,4.124,0,0,1-3.175.4.363.363,0,0,1-.249-.343V1.256a.356.356,0,0,1,.144-.29A.344.344,0,0,1,2.4.908,3.471,3.471,0,0,0,5.091.536c1.253-.545,2.546-1.12,4.587.716C11.711-.577,13-.01,14.264.536a3.451,3.451,0,0,0,2.684.372.344.344,0,0,1,.315.058.355.355,0,0,1,.144.29V12.818a.354.354,0,0,1-.249.343,4.13,4.13,0,0,1-3.176-.4c-1.24-.548-2.224-.976-4.061.8a.381.381,0,0,1-.053.044.237.237,0,0,1-.079.039.385.385,0,0,1-.112.017A.239.239,0,0,1,9.566,13.641Zm4.7-1.543a3.688,3.688,0,0,0,2.434.443V1.719a4.434,4.434,0,0,1-2.717-.511c-1.22-.54-2.185-.964-3.95.691V12.509a3.658,3.658,0,0,1,2.3-.952A4.786,4.786,0,0,1,14.264,12.1ZM2.651,12.54a3.713,3.713,0,0,0,2.44-.443,3.463,3.463,0,0,1,4.232.411V1.9C7.552.244,6.587.667,5.367,1.208a4.432,4.432,0,0,1-2.716.511Z",
    transform: "translate(4.925 4.789)",
    fill: "#6db3e0"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleguides);
export default __webpack_public_path__ + "static/media/styleguides.71ceb3f15b8f73f37ae3fffe78d2d323.svg";
export { ForwardRef as ReactComponent };